import * as React from "react";
import PropTypes from "prop-types";

export default class ResetPassword extends React.Component {
    constructor (props) {
        super(props);
    }

    render () {
        return (
            <div id="ResetPassword" className={this.props.visible ? "col-md-12" : "hidden"}>
                <p>
                    <span>Password for User ID {this.props.login} has been reset to </span>
                    <span id="ResetPasswordValue"><b>{this.props.newPassword}</b></span>
                </p>
                <p>
                    <span className="helpText">
                        Please make note of this new password.
                        This password reset is effective for applications the user has access to including Sentri7, Quantifi and/or VeriForm. Please note, users may not have access to all of those applications.
                    </span>
                </p>
            </div>
        );
    }
}

ResetPassword.propTypes = {
    login: PropTypes.number,
    newPassword: PropTypes.string,
    visible: PropTypes.bool.isRequired
};
